import process from 'process'; // Mova para cá
import { ReactNotifications } from 'react-notifications-component'; // Com chaves e nome no plural
import "react-notifications-component/dist/theme.css";
import Routes from "./routes";

function App() {
  return (
    <>
      <ReactNotifications /> {/* Mude o nome aqui também */}
      <Routes />
    </>
  );
}

export default App;
